export const jiraSuperBatchDependencies = [
	// SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
	'wrc!jira.webresources:skate',
	'wrc!jira.webresources:util-lite',
	'wrc!jira.webresources:util',
	'wrc!jira.webresources:feature-flags',
	'wrc!jira.webresources:dialogs',
	'wrc!jira.webresources:jira-global',
	'wrc!com.atlassian.auiplugin:aui-spinner',
];
